export type FeaturedVideoType = {
  id: number;
  title: string;
  participantName: string;
  participantDetails: string;
  thumbnail: string;
  kalturaId: string;
  durationInSeconds: number;
};

export const featuredVideosContent = [
  {
    id: 1,
    title: 'O FUTURO DA EDUCAÇÃO',
    participantName: 'Daniel Pedrino',
    participantDetails: 'Reitor da Faculdade',
    thumbnail:
      'https://cdnsecakmi.kaltura.com/p/1612851/thumbnail/entry_id/1_17wxaae9/width/1280/height/720',
    kalturaId: '1_17wxaae9',
    durationInSeconds: 60,
  },
];
